module.exports = __webpack_public_path__ + "img/p124.f5384d26.jpg";